// extracted by mini-css-extract-plugin
export default {"root":"AZZ720XLtlqONvvXEGn4","header":"l77tRT9BIXmMBXpj1NBA","title":"B8Eyj6wCRIgx7mnwPuYA","x":"rBtXanZ5J8H8Dco_8gPf","footer":"qv2JCiEEC0R0JWIoRXS2"};